import { motion } from "framer-motion";

const chapters = [
  {
    number: "01",
    title: "Peinture Classique et Décorative",
    tagline: "Mat velouté, laques microporeuses, stucs et chaux aérienne",
    description:
      "Préparation chirurgicale des fonds (ponçage aspirant sans poussière, ratissage complet, sous-couche d'accroche). Application de peintures certifiées A+ garantissant un tombé de lumière sans aucune trace de reprise.",
    specs: ["Sous-couches microporeuses", "Enduisage en 2 passes croisées", "Peintures biosourcées sans COV", "Ponçage aspiré"],
  },
  {
    number: "02",
    title: "Rénovation du Second Oeuvre du Bâtiment",
    tagline: "De la remise aux normes au raffinement architectural",
    description:
      "Reprise intégrale des plâtres dégradés, faux plafonds acoustiques, dépose de cloisons, reprises de fissures structurelles et coordination des finitions avec architectes et décorateurs.",
    extra:
      "Isolation intérieure et des combles : pose d'isolants biosourcés (laine de bois, ouate de cellulose) ou de complexes doublage-collage, traitement des ponts thermiques et pare-vapeur posé dans les règles de l'art. Des combles bien isolés, c'est jusqu'à 30 % d'économies de chauffage et un confort été comme hiver.",
    specs: ["Remise à neuf après dégât des eaux", "Doublages & isolation", "Moulures & corniches", "Calendrier maîtrisé"],
  },
  {
    number: "03",
    title: "Ravalement de Façades & Extérieur",
    tagline: "Pérennité esthétique et bouclier contre les intempéries",
    description:
      "Nettoyage haute pression raisonné, traitement fongicide et anti-mousse, réparation des épaufrures béton et enduits minéraux siloxanes respirants résistants aux UV.",
    specs: ["Système I1 à I4 selon DTU 42.1", "Enduit taloché fin ou gratté", "Peintures pliolites et silicates", "Boiseries extérieures"],
  },
  {
    number: "04",
    title: "Revêtements de Sols & Boiseries Nobles",
    tagline: "Restauration des parquets et finitions soyeuses",
    description:
      "Ponçage de parquets anciens, vitrification mate ou huilage écologique, pose de parquets massifs et stratifiés haute résistance, laquage des menuiseries et huisseries.",
    specs: ["Vitrificateurs polyuréthane aqua", "Huiles dures naturelles", "Sous-couches phoniques", "Plinthes en affleurement"],
  },
  {
    number: "05",
    title: "Sols Béton Effet Pierre",
    tagline: "Un rendu minéral continu, façon pierre naturelle",
    description:
      "Coulage et talochage réalisés à la main, pigments dans la masse et patine minérale pour un rendu pierre naturelle sans joint apparent. Protection hydrofuge et oléofuge, grande résistance à l'usure et entretien simple : idéal pour les séjours, cuisines et salles de bain.",
  },
];

export const ManifestoChapters = () => {
  return (
    <section id="savoir-faire" className="py-28 lg:py-36" data-testid="manifesto-section">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className="max-w-3xl mb-20"
        >
          <p className="font-mono-tech text-xs uppercase tracking-[0.25em] text-[#9E5A38] mb-5">
            Les compétences certifiées
          </p>
          <h2 className="font-serif-display text-3xl sm:text-4xl lg:text-5xl font-normal tracking-tight leading-[1.15] text-[#1C1815]">
            Les savoir-faire de l'entreprise
          </h2>
          <p className="mt-6 text-base sm:text-lg font-light leading-relaxed text-[#59524A]">
            Cinq disciplines, une même obsession : la perfection de la surface
            et la durabilité de l'ouvrage.
          </p>
        </motion.div>

        <div className="space-y-0">
          {chapters.map((c, i) => (
            <motion.article
              key={c.number}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1], delay: i * 0.08 }}
              className="group grid lg:grid-cols-12 gap-6 lg:gap-10 py-12 lg:py-16 border-t border-[#1A1714]/10 last:border-b"
              data-testid={`manifesto-chapter-${c.number}`}
            >
              <div className="lg:col-span-2">
                <span className="font-serif-display italic text-4xl lg:text-5xl font-light text-[#C4B29E] group-hover:text-[#9E5A38] transition-colors duration-500">
                  {c.number}
                </span>
              </div>
              <div className="lg:col-span-5">
                <h3 className="font-serif-display text-2xl lg:text-3xl font-medium tracking-tight text-[#1C1815]">
                  {c.title}
                </h3>
                <p className="mt-3 font-serif-display italic text-base text-[#8A7E72]">{c.tagline}</p>
              </div>
              <div className="lg:col-span-5">
                <p className="text-sm sm:text-base font-normal leading-relaxed text-[#4A433D]">{c.description}</p>
                {c.extra && (
                  <p className="mt-4 text-sm sm:text-base font-normal leading-relaxed text-[#4A433D] border-l-2 border-[#9E5A38]/40 pl-4">
                    {c.extra}
                  </p>
                )}
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};
